import gql from "graphql-tag"
import fullProduct from "@irati/products/services/fragments/fullProduct"
import fullDeal from "@irati/deals/services/queries/fragments/fullDeal"

const fullBasket = gql`
  fragment fullBasket on Basket {
    userId
    items {
      amount
      openValue
      count
      entityId
      entityType
      productId
      product {
       ...fullProduct
      }
      targetUserId
      deal {
        ...fullDeal
      }
    }
    total {
      discountPercentage
      originalPrice
      amount
      serviceCharge
      discountPercentageAfterServiceCharge
      currency
      vat
    }
    cashback {
      amount
    }
    shippingAddress {
      firstName
      lastName
      email
      address1
      address2
      postalCode
      city
      state
      countryCode
      phoneNumber
    }
  }
  ${fullProduct}
  ${fullDeal}
`

export default fullBasket
